<template>
	<div v-if="addon.IsProductActive">
		<div>
			<button class="variant-selector flex" @click="showList = true">
				<span v-if="quantitySelected > 0"
					>{{ quantitySelected }} added (<currency
						:value="selectedPrice"
					/>)</span
				>
				<span v-else>Select</span>
			</button>
		</div>
		<span>{{ variantSummary }}</span>
		<div class="variant-window" v-if="showList">
			<div class="variant-overlay-bg" @click.stop="showList = false" />
			<div class="variant-content">
				<h4 class="addon-name">{{ addon.AddOnName }}</h4>
				<ul class="variant-list">
					<li
						v-for="v in addon.Variants"
						:key="v.ProductKey"
						class="flex"
						v-show="v.IsProductActive"
					>
						<div class="variant-desc">
							<h4>
								{{ v.ProductName }}
							</h4>
							<currency
								:value="v.PublishedPrice"
								:class="{ strikethrough: v.AddOnDiscount }"
							/>
							<currency v-if="v.AddOnDiscount && price(v)" :value="price(v)" />
							<span v-if="!price(v)">Free!</span>
							<span v-if="v.Quantity">
								(<currency :value="price(v) * v.Quantity" /> total )
							</span>
						</div>
						<number-ticker v-model="v.Quantity" @input="onInput" />
					</li>
				</ul>
				<div class="variant-footer flex">
					<button class="button blue" @click="onVariantAdd()">Done</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import NumberTicker from '../components/NumberTicker.vue';
	export default {
		props: ['addon'],
		name: 'VariantSelector',
		components: {
			NumberTicker,
		},
		data() {
			return {
				showList: false,
				addonOnClone: null,
			};
		},
		created() {
			this.addonOnClone = JSON.parse(JSON.stringify(this.addon));
		},
		computed: {
			quantitySelected() {
				return this.addon.Variants.reduce((p, c) => (p += c.Quantity), 0);
			},
			selectedPrice() {
				return this.addon.Variants.reduce(
					(p, c) => (p += c.Quantity * (c.PublishedPrice - c.AddOnDiscount)),
					0
				);
			},
			variantSummary() {
				return this.addon.Variants.reduce((p, c) => {
					if (c.Quantity > 0) {
						let item = c.ProductName;
						if (c.Quantity > 1) item += ` x ${c.Quantity}`;
						p.push(item);
					}
					return p;
				}, []).join(', ');
			},
		},
		methods: {
			price(v) {
				var discount = v.AddOnDiscount ? v.AddOnDiscount : 0;
				return v.PublishedPrice - discount;
			},

			onVariantAdd() {
				this.showList = false;
			},
			onInput() {
				this.addon.Quantity = this.quantitySelected;
			},
		},
	};
</script>

<style lang="scss">
	button.variant-selector {
		height: 44px;
		width: 80%;
		border-radius: 3px;
		background: #edf1f5;
		outline: none;
		border: none;
		cursor: pointer;

		> span {
			color: #09f;
			font-size: 16px;
			padding: 0 8px;
		}
	}

	.variant-window {
		position: fixed;
		height: 100vh;
		width: 100vw;
		z-index: 999999;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.variant-overlay-bg {
		height: 100%;
		width: 100%;
		background: #0000006e;
	}

	.variant-content {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 500px;
		max-height: 80%;
		max-width: 90vw;
		overflow: hidden;
		background: #fff;
		z-index: 999999;
		border-radius: 8px;

		> .addon-name {
			text-align: center;
			font-weight: bold;
			margin: 0;
			padding: 10px;
			border-bottom: 1px solid #ccc;
		}

		ul.variant-list {
			list-style: none;
			padding: 0;
			margin: 0;
			max-height: 501px;

			overflow-y: scroll;

			&::-webkit-scrollbar {
				// display: none;
			}

			li {
				padding: 0 20px;
			}
		}

		.variant-desc {
			h4 {
				margin: 0;
			}
		}
	}

	.variant-footer {
		height: 60px;
		// width: 100%;
		padding: 10px;
		justify-content: flex-end;
		border-top: 1px solid #ccc;

		button {
			min-width: 120px;
		}
	}
</style>
